import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteConfigProvider } from "@/context/SiteConfigContext";
import { AuthProvider } from "@/context/AuthContext";
import { SiteLayout } from "@/components/site/SiteLayout";
import { ProtectedRoute } from "@/pages/admin/ProtectedRoute";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Jupeb from "@/pages/Jupeb";
import Ijmb from "@/pages/Ijmb";
import Remedial from "@/pages/Remedial";
import Programmes from "@/pages/Programmes";
import Admissions from "@/pages/Admissions";
import StudentInfo from "@/pages/StudentInfo";
import Faqs from "@/pages/Faqs";
import Contact from "@/pages/Contact";
import Announcements from "@/pages/Announcements";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SiteConfigProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<SiteLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/jupeb" element={<Jupeb />} />
                <Route path="/ijmb" element={<Ijmb />} />
                <Route path="/remedial" element={<Remedial />} />
                <Route path="/programmes" element={<Programmes />} />
                <Route path="/admissions" element={<Admissions />} />
                <Route path="/student-information" element={<StudentInfo />} />
                <Route path="/faqs" element={<Faqs />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/announcements" element={<Announcements />} />
              </Route>
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </SiteConfigProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
